import React from 'react'
import { OneColorIconProps } from '../utils'

export const TomatoIcon: React.FC<OneColorIconProps> = ({ size = 48, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4998_476552)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.6709 21.6557C39.2852 15.4714 36.1401 10.8445 31.4078 8.25781C31.4347 8.40852 31.3006 8.5969 31.1479 8.53018C28.0526 7.17615 22.8017 11.5582 19.1323 9.26346C19.1599 10.087 18.999 14.1045 13.3398 14.3375C13.2062 14.343 13.1326 14.2065 13.2171 14.1099C13.974 13.2467 14.7381 11.0611 13.6394 9.89599C11.2863 12.0045 9.91986 12.7981 5.40816 11.7509C2.51953 14.7713 0.88268 18.9053 1.20401 24.055C1.85961 34.5675 11.7064 40.5766 21.6223 39.9579C31.5375 39.3396 40.3267 32.1682 39.6709 21.6557Z"
          fill="#FA320A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6001 5.73227C23.6376 5.24662 29.4982 5.68496 31.3758 8.17575C31.4885 8.32513 31.3299 8.60779 31.1481 8.52845C28.0529 7.17442 22.8019 11.5565 19.1325 9.26173C19.1601 10.0853 18.9992 14.1027 13.34 14.3358C13.2064 14.3412 13.1329 14.2048 13.2173 14.1082C13.9742 13.245 14.7382 11.0594 13.6396 9.89426C11.0764 12.1912 9.68688 12.9293 4.12372 11.4255C3.94165 11.3764 4.00372 11.0838 4.19742 11.0099C5.24887 10.6081 7.63094 8.84812 9.88455 8.07235C10.3136 7.9248 10.7413 7.81028 11.1587 7.74372C8.67742 7.52198 7.55891 7.17692 5.98065 7.41492C5.80771 7.44098 5.6902 7.23965 5.79742 7.10156C7.92389 4.36247 11.8412 3.53526 14.2582 4.99036C12.7684 3.14438 11.6014 1.67218 11.6014 1.67218L14.3665 0.101562C14.3665 0.101562 15.509 2.65393 16.3402 4.51152C18.3971 1.47235 22.2241 1.19185 23.8411 3.3482C23.937 3.47633 23.8368 3.65857 23.6766 3.65476C22.3606 3.62272 21.6359 4.81974 21.581 5.73011L21.6001 5.73227Z"
          fill="#00912D"
        />
      </g>
      <defs>
        <clipPath id="clip0_4998_476552">
          <rect width="40" height="40" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
